import React, { PureComponent } from "react";
import { Link, Router,withRouter  } from "react-router-dom";
import { Message } from "element-react";
import { getToken, getCurrentUser } from 'utils/storage';

import customer from "../../images/icon-customer.png";
import customerDefault from "../../images/icon-customer-default.png";
import work from "../../images/icon-work.png";
import workDefault from "../../images/icon-work-default.png";
import complaint from "../../images/icon-complanit.png";
import complaintDefault from "../../images/icon-complaint-default.png";
import user from "../../images/icon-user.png";
import userDefault from "../../images/icon-user-default.png";

require("./index.scss");

class navigation extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [{ id: 1, name: '智能客服', defaultimg: customerDefault, img: customer, url: '/entrance/customService' },
      { id: 2, name: '进度查询', defaultimg: workDefault, img: work, url: 'workservice' },
      { id: 3, name: '投诉建议', defaultimg: complaintDefault, img: complaint, url: 'https://zwfw.nmg.gov.cn/sso//sso/login?utype=0&redirect=istrue&client_id=BI3LH75LM&goto=/complaint?regionCode=150000' },
      { id: 4, name: '用户指引', defaultimg: userDefault, img: user, url: "../../tyjrmh/download/内蒙古退役军人门户系统操作说明.pdf" }],
      userdata: '',
      token: ''
    };

  }

  componentWillMount() {
    const user = getCurrentUser();
    const token = getToken();
    this.setState({
      userdata: user,
      token: token
    })
  }

  handleUser = () => {
    Message({
      message: '请先登录！',
      type: 'warning'
    });
    return;
  }

  handleComplanit = (url) => {
    window.open(url);
  }

  jingdu = (url) => {
    console.log(' 进度查询')
    if (this.state.userdata) {      
      this.props.history.push({ pathname: '/entrance/main' })
    } else {
      Message({
        message: '请先登录！',
        type: 'warning'
      });
      return;
    }
  }

  render() {
    const { data, activekey, userdata, token } = this.state;
    return (
      <div className="navigation">
        {data && data.length > 0 && data.map((item, i) => {
          if (item.id == 4) {
            // if (!userdata||!token) {
            //   return (
            //     <Link key={i} to={{pathname: ''}} onClick={() => this.handleUser()}>
            //       <div key={i} className="nav-children" >
            //         <div className="nav-img">
            //           {/* <img src={item.defaultimg} /> */}
            //         </div>
            //         <div style={{ marginTop: 5 }}>{item.name}</div>
            //       </div>
            //     </Link>
            //   )
            // } else {
            return (
              <a key={i} href={item.url}>
                <div key={i} className="nav-children" >
                  <div className="nav-img">
                    {/* <img src={item.defaultimg} /> */}
                  </div>
                  <div style={{ marginTop: 5 }}>{item.name}</div>
                </div>
              </a>
            )
            // }
          } else if (item.id == 3) {
            return (
              <Link key={i} to={{ pathname: '' }} onClick={() => this.handleComplanit(item.url, item.id)}>
                <div key={i} className="nav-children" >
                  <div className="nav-img">
                    {/* <img src={item.defaultimg} /> */}
                  </div>
                  <div style={{ marginTop: 5 }}>{item.name}</div>
                </div>
              </Link>
            )
          } else if (item.id == 1) {
            return (
              <Link key={i} to={{ pathname: item.url }} >
                <div key={i} className="nav-children" >
                  <div className="nav-img">
                    {/* <img src={item.defaultimg} /> */}
                  </div>
                  <div style={{ marginTop: 5 }}>{item.name}</div>
                </div>
              </Link>
            )
          } else {
            return (
              <Link key={i} to={{ pathname: '' }} onClick={() => this.jingdu(item.url, item.id)}>
                <div key={i} className="nav-children" >
                  <div className="nav-img">
                    {/* <img src={item.defaultimg} /> */}
                  </div>
                  <div style={{ marginTop: 5 }}>{item.name}</div>
                </div>
              </Link>
            )
          }
        })}
      </div>
    );
  }
}


export default withRouter(navigation)